/**
 * PERSON SOURCE THUNKS — read-only.
 *
 * Solo `fetchPersonSources` (paginated GET /people/{groupId}/sources).
 * Niente fetchOne/create/update/remove perché il backend non espone CRUD
 * (vedi commento in personSourceApi.ts). Definito a mano via
 * `createAsyncThunk` invece di usare `createCrudThunks` per non costringere
 * a stub api che lanciano READ_ONLY_ERROR — pattern bespoke legittimo per
 * lookup read-only.
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import type { Page, ServerListParams } from '@crm/shared';
import type { RootState } from '../../store/store';
import { requireGroupId, extractError } from '../../store/thunkHelpers';
import { personSourceApi } from './personSourceApi';
import type { PersonSource } from './personSourceTypes';

export const fetchPersonSources = createAsyncThunk<
  Page<PersonSource>,
  ServerListParams | undefined,
  { state: RootState; rejectValue: string }
>('personSources/fetchAll', async (params, { getState, rejectWithValue }) => {
  try {
    return await personSourceApi.getAll(requireGroupId(getState), params);
  } catch (err: unknown) {
    return rejectWithValue(extractError(err));
  }
});
